import styled, { css } from 'styled-components';
import { type } from '../../styles/typography';

const TONES = {
  dark: css`
    background-color: var(--b-graphite);
    color: var(--b-white);
  `,
  white: css`
    background-color: var(--b-white);
    color: var(--b-black);
  `,
  fog: css`
    background-color: var(--b-fog);
    color: var(--b-black);
  `,
  translucent: css`
    background-color: rgba(255, 255, 255, 0.64);
    color: var(--b-black);
  `,
};

const Chip = styled.span`
  ${({ uppercase }) => type('label', 'small', { uppercase: Boolean(uppercase) })};
  ${({ tone }) => TONES[tone] || TONES.dark};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 15px;
  border-radius: ${({ pill }) => (pill ? '100px' : 'var(--b-radius-s)')};
  white-space: nowrap;
`;

export default Chip;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/brand/Chip.js